import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CompanyBenefitPolicyLabelPartModel,
  CompanyBenefitPolicyLabelPartTypeEnum,
  CompanyBenefitPolicyRequiredCheckboxDTO,
  RequiredConsentState,
} from 'app/core/models/company-benefit-policy';
import { OrderConsentSubmissionModel } from 'app/core/models/order-policy-submission';

@Component({
  selector: 'app-required-consents',
  templateUrl: './required-consents.component.html',
  styleUrls: ['./required-consents.component.scss'],
})
export class RequiredConsentsComponent {
  private _consents: RequiredConsentState[] = [];

  @Input() set checkboxes(value: CompanyBenefitPolicyRequiredCheckboxDTO[]) {
    const previousMap = new Map(this._consents.map((c) => [c.composedName, c]));
    this._consents = (value || [])
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map((item) => {
        const composedName = this.composeConsentName(item.labelParts);
        const previous = previousMap.get(composedName);
        return { ...item, composedName, checked: previous?.checked ?? false };
      });
  }

  @Output() consentChange = new EventEmitter<void>();

  readonly policyLabelPartTypes = CompanyBenefitPolicyLabelPartTypeEnum;

  get consents(): readonly RequiredConsentState[] {
    return this._consents;
  }

  public isComplete(): boolean {
    return this._consents.filter((c) => c.isRequired).every((c) => c.checked === true);
  }

  public getSubmittedConsents(): Array<OrderConsentSubmissionModel> {
    return this._consents.map((c) => ({ requiredCheckboxId: c.id, name: c.composedName, checked: c.checked }));
  }

  onCheckboxChange(): void {
    this.consentChange.emit();
  }

  private composeConsentName(labelParts: Array<CompanyBenefitPolicyLabelPartModel>): string {
    return (labelParts || [])
      .map((part) => part.text)
      .filter((text) => !!text && text.trim().length > 0)
      .join(' ');
  }
}
